import React, { FC } from 'react';
import * as OrderSummary from '../../shared/orders/model';
import { cToUsdStrPref } from '../utils/cToUsdStr';

interface OptionViewerProps {
  readonly optionOrderItems: OrderSummary.OrderItemOption[];
}

export const OptionViewer: FC<OptionViewerProps> = ({ optionOrderItems }) => {
  return (
    <>
      {optionOrderItems.map((option) => {
        const { type, priceModifier, value, name, valueDisplayName } = option;

        return (
          <div className="order-item-option" key={option.optionId}>
            <div className="order-item-option-body">
              <strong>{name}</strong>:{' '}
              {valueDisplayName ??
                (type === 'currency' ? cToUsdStrPref(Number.parseInt(value!, 10)) : value)}
              {priceModifier > 0 && ` (${cToUsdStrPref(priceModifier)})`}
            </div>
          </div>
        );
      })}
    </>
  );
};
